import { Description, Title, Wrapper } from "./WelcomeMessageStyles";
import { FaRegHandPaper } from "react-icons/fa";

const WelcomeMessage = () => {
  return (
    <Wrapper>
      <Title>
        Olá, João <FaRegHandPaper />
      </Title>
      <Description>
        Pronto para montar seu Press Kit profissional?
        <br />
        Veja abaixo uma prévia de como o seu perfil pode ser apresentado para
        contratantes:
      </Description>
    </Wrapper>
  );
};

export default WelcomeMessage;
